import useId from '../utils/useId';
import * as React from 'react';
export const commerzbankSvg = React.forwardRef(function commerzbankSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  const id_3 = baseId + '_3';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.112 5.92a3.868 3.868 0 0 0-3.135 1.77l.058.068c.39-.465.844-.873 1.349-1.211a3.565 3.565 0 0 1 1.454-.55c.326-.036 1.404-.023 2.63-.023a.013.013 0 0 1 .015 0l-.031-.054h-2.34Z',
      fill: `url(#bi_commerzbank__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.562 5.92h-.012l-4.566 7.915-1.432 2.48-.166.291-.022.034v.014l4.35 7.533v-.032a4.724 4.724 0 0 1-.197-.39 3.548 3.548 0 0 1-.26-1.535 8.535 8.535 0 0 1 1.24-3.573l2.684-4.647 2.683-4.655a8.536 8.536 0 0 1 2.473-2.857 3.542 3.542 0 0 1 1.455-.544c.327-.038 1.41-.039 2.64-.039h-10.87v.006-.001Z',
      fill: `url(#bi_commerzbank__b_${id_1})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.282 18.921a3.556 3.556 0 0 1-1.202.99 8.565 8.565 0 0 1-3.712.714H10.633a8.56 8.56 0 0 1-3.712-.714 3.554 3.554 0 0 1-1.201-.99c-.17-.23-.603-.968-1.115-1.855l1.09 1.89 4.109 7.117h12.375l.012-.01 5.389-9.333c-.593 1.03-1.116 1.926-1.31 2.182l.012.009Z',
      fill: `url(#bi_commerzbank__c_${id_2})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.797 5.963a3.542 3.542 0 0 0-1.453.545 6.223 6.223 0 0 0-1.343 1.21c.427.513.807 1.063 1.136 1.644l2.684 4.655 2.684 4.654a8.538 8.538 0 0 1 1.236 3.573 3.592 3.592 0 0 1-.256 1.536c-.127.29-.628 1.163-1.21 2.171l5.363-9.299v-.01L21.451 5.928h-.012c-1.23 0-2.314 0-2.642.04',
      fill: `url(#bi_commerzbank__d_${id_3})`,
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_commerzbank__a_${id_0}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform: 'matrix(26.9116 0 0 26.901 259.754 1776.56)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FEDF33',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.44,
          stopColor: '#FBB809',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.9,
          stopColor: '#EE960D',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#E17A10',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_commerzbank__b_${id_1}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform: 'matrix(1579.12 0 0 1579.03 1176.85 5.909)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FEDF33',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.44,
          stopColor: '#FBB809',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.9,
          stopColor: '#EE960D',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#E17A10',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_commerzbank__c_${id_2}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform: 'matrix(1558.95 0 0 1559.06 152.513 613.098)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FEDF33',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.44,
          stopColor: '#FBB809',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.9,
          stopColor: '#EE960D',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#E17A10',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_commerzbank__d_${id_3}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform: 'matrix(1763.45 0 0 1763.32 791.316 989.55)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FEDF33',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.44,
          stopColor: '#FBB809',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.9,
          stopColor: '#EE960D',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#D87301',
        }),
      ),
    ),
  );
});
commerzbankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var commerzbank = {
  category: 'brand',
  colorable: false,
  name: 'commerzbank',
  svg: commerzbankSvg,
};
